app-accordion {

    .app-accordion {
        background: #fff;
        box-shadow: 0px 8px 16px #00000029;
        @include paddings(20,16,18,16);
        overflow: hidden;
        transition: transform 350ms;
        @include margin-direction(bottom, 16);


        h3 {
            font-family: $font-family-primary-bold;
            @include text-size(23);
            @include line-height(23);
            margin-bottom: 0;
            color: $gray-dark;
            transition: all 350ms;
            user-select: none;
            position: relative;
            @include padding-direction(right, 22);

            .icon {
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                display: inline-block;
                transition: transform 350ms;

                svg {
                    @include svg-format(21px, 24px, $primary);
                    @include margin-direction(top, 5);
                }
            }
        }

        .app-accordion-content {
            max-height: 0;
            overflow: hidden;
            transition: max-height 350ms;

            .app-accordion-content-inner {
                @include margin-direction(top, 29);

                p {
                    @include text-size(16);
                    @include line-height(24);
                    padding-bottom: 0;

                    // Handle multiple p tags placed in accordion content
                    &+p {
                        @include padding-direction(top, 10);
                    }
                }

                strong {
                    font-family: $font-family-primary-bold;
                }

                a {
                    text-decoration: underline;

                    &:hover,
                    &:focus {
                        text-decoration: none;
                    }
                }
            }
        }

        &.open {

            h3 {
                .icon {
                    transform: rotate(180deg) translateY(50%);
                }
            }

            .app-accordion-content {
                // max-height: 225px;
                max-height: none;
            }
        }

    }

    @include media-breakpoint-down(xl) {
        .app-accordion {
            @include paddings(19,16,17,16);

            h3 {
                @include text-size(16);
                @include line-height(24);
            }

            .app-accordion-content {
                .app-accordion-content-inner {
                    @include margin-direction(top, 25);
                }
            }

            &.open {

                .app-accordion-content {
                    max-height: none;
                }
            }
        }
    }
}